// extracted by mini-css-extract-plugin
export default {"container":"mKomEG","horizontal":"A9olU5","centerPieChart":"oVeG9U"};